import { IQuoteSection } from 'types/quote'
import InfoArea from './InfoArea'
import InfoAreaTable from 'components/quote/simple/confirm/InfoAreaTable'
import InfoAreaFile from 'components/quote/InfoAreaFile';
import { ReactComponent as Frozen } from 'assets/quote/frozen.svg'
import { ReactComponent as Danger } from 'assets/quote/danger.svg'

const Third = ({ quoteInfo, file }: IQuoteSection) => {
    const tHeader = [
        { label: "No.", flex: 0.5, type: '' },
        { label: "CNTR", flex: 1, type: '' },
        { label: "G.Weight", flex: 1, type: '' },
        { label: "수량", flex: 1, type: '' },
        ...(quoteInfo?.step1?.transportType === 'SEA' && quoteInfo?.step2?.shipmentMode === 'FCL-DRY'
            ? [
                { label: "FLEXI BAG", flex: 1, type: 'FCL' },
                { label: "냉장/냉동", flex: 1, type: 'FCL' },
                { label: "위험물", flex: 1, type: 'FCL' },
            ]
            : []),
    ];
    const tHeader2 = [
        { label: "No.", flex: 0.5 },
        { label: "Packing Unit", flex: 1.0 },
        { label: "수량", flex: 0.5 },
        { label: "Dimension(Cm)", flex: 1.2 },
        { label: "C.Weight(Kg)", flex: 1.2 },
        { label: "다단 적재", flex: 1.0 },
        ...(quoteInfo?.step1?.transportType === 'SEA' && quoteInfo?.step2?.shipmentMode === 'OT'
            ? [{ label: "GAGE", flex: 0.5 }]
            : []),
    ];

    return (
        <div className='bg-white border-[#9D9EB7] border-1 rounded-lg'>
            <div className='bg-[#F8F8FA] px-10 py-6 rounded-t-lg'>
                <p className='font-semibold first-line:text-2xl'>화물 정보</p>
            </div>

            <div className='flex flex-col gap-6 px-10 py-6'>
                <InfoArea
                    title='화물 출고일'
                    value={quoteInfo?.isShippingDate ? '출고일확정' : '출고일미정'}
                />
                {
                    quoteInfo.step2?.shippingDate &&
                    <InfoArea
                        title=''
                        value={quoteInfo.step2?.shippingDate}
                    />
                }
                {
                    quoteInfo.step2?.shipmentMode &&
                    <InfoArea
                        title='운송 유형'
                        value={quoteInfo.step2.shipmentMode}
                    />
                }
                {
                    quoteInfo?.step1?.transportType === 'SEA' &&
                    (quoteInfo?.step2?.shipmentMode === 'FCL-DRY' || quoteInfo?.step2?.shipmentMode === 'OT') &&
                    <InfoAreaTable
                        title='화물정보'
                    >
                        <div className='flex bg-[#F8F8FA] border-[#9D9EB7] border-t-1 font-semibold text-sm'>
                            {
                                tHeader.map((item, idx) => (
                                    <div
                                        key={idx}
                                        className={`flex-[${item.flex}] flex items-center justify-center h-10`}
                                    >
                                        {item.label}
                                    </div>
                                ))
                            }
                        </div>
                        {
                            quoteInfo?.step2.containerList.map((item, idx) => (
                                <div
                                    className={`flex h-15 font-semibold text-sm ${idx === quoteInfo?.step2?.containerList?.length - 1 ? 'border-b-1 border-[#9D9EB7]' : ''} `}
                                    key={idx}>
                                    <div className='flex flex-[0.5] justify-center items-center'>{idx + 1}</div>
                                    <div className='flex flex-[1] justify-center items-center'>
                                        {item.containerType}
                                    </div>
                                    <div className='flex flex-[1] justify-center items-center'>
                                        {Number(item.containerWeight).toLocaleString()} Kg
                                    </div>
                                    <div className='flex flex-[1] justify-center items-center'>
                                        {item.containerQuantity}
                                    </div>
                                    {
                                        quoteInfo?.step2?.shipmentMode !== 'OT' &&
                                        <>
                                            <div className='flex flex-[1] justify-center items-center'>
                                                {item.flexiBag !== undefined && (item.flexiBag ? '예' : '아니요')}
                                            </div>
                                            <div className='flex flex-col flex-[1] justify-center items-center'>
                                                <Frozen className="shrink-0" fill={item.isFrozen ? '#196BFF' : '#9D9EB7'} />
                                                {
                                                    item.isFrozen &&
                                                    <p className='text-xs text-center leading-none'>
                                                        {item.tempMin}°C ~ {item.tempMax}°C
                                                    </p>
                                                }
                                                {
                                                    item.isVent !== undefined &&
                                                    <p className='text-center leading-none'>
                                                        Vent: {item.isVent ? "Open" : "Close"}
                                                    </p>
                                                }
                                            </div>
                                            <div className={`flex-[1] flex items-center justify-center`}>
                                                <Danger fill={item.isDangerous ? '#FF0000' : '#9D9EB7'} />
                                            </div>
                                        </>
                                    }
                                </div>
                            ))
                        }
                    </InfoAreaTable>
                }
                {
                    quoteInfo?.step2?.packingList &&
                    quoteInfo?.step2?.packingList.length > 0 &&
                    quoteInfo?.step2?.packingList[0].quantity > 0 &&
                    <>
                        <InfoAreaTable
                            title='포장정보'
                        >
                            <div className='flex bg-[#F8F8FA] border-[#9D9EB7] border-t-1 font-semibold text-sm'>
                                {
                                    tHeader2.map((item, idx) => (
                                        <div
                                            key={idx}
                                            className={`flex-[${item.flex}] flex items-center justify-center h-10`}
                                        >
                                            {item.label}
                                        </div>
                                    ))
                                }
                            </div>
                            {
                                quoteInfo?.step2?.packingList.map((item, idx) => (
                                    <div
                                        className={`flex h-10 font-semibold text-sm ${idx === quoteInfo?.step2?.packingList?.length - 1 ? 'border-b-1 border-[#9D9EB7]' : ''} `}
                                        key={idx}>
                                        <div className='flex flex-[0.5] justify-center items-center'>{idx + 1}</div>
                                        <div className='flex flex-[1] justify-center items-center'>
                                            {item.packageType}
                                        </div>
                                        <div className='flex flex-[0.5] justify-center items-center'>
                                            {item.quantity}
                                        </div>
                                        <div className='flex flex-[1.2] justify-center items-center'>
                                            {item.width} * {item.height} * {item.length}
                                        </div>
                                        <div className='flex flex-[1.2] justify-center items-center'>
                                            {quoteInfo?.step1?.transportType === 'AIR' ? item.chargeableWeight : item.weight} Kg
                                        </div>
                                        <div className='flex flex-[1] justify-center items-center'>
                                            {item.isStackable ? '예' : '아니오'}
                                        </div>
                                        {
                                            quoteInfo?.step1?.transportType === 'SEA' &&
                                            quoteInfo?.step2?.shipmentMode === 'OT' &&
                                            <div className='flex flex-[0.5] justify-center items-center'>
                                                {item.gage}
                                            </div>
                                        }
                                    </div>
                                ))
                            }
                        </InfoAreaTable>
                        {
                            quoteInfo?.step1?.transportType === 'SEA' &&
                            quoteInfo.cbm &&
                            quoteInfo.cbm > 0 &&
                            <InfoArea
                                title='CBM'
                                value={`${quoteInfo.cbm.toLocaleString()} CBM`}
                            />
                        }
                        {
                            quoteInfo?.step1?.transportType === 'SEA' &&
                            quoteInfo.totalWeight &&
                            quoteInfo.totalWeight > 0 &&
                            <InfoArea
                                title='총중량'
                                value={`${quoteInfo.totalWeight.toLocaleString()} Kg`}
                            />
                        }
                        {
                            quoteInfo?.step1?.transportType === 'AIR' &&
                            quoteInfo.totalCW &&
                            quoteInfo.totalCW > 0 &&
                            <InfoArea
                                title='G C/W'
                                value={`${quoteInfo.totalCW.toLocaleString()} Kg`}
                            />
                        }
                    </>
                }
                <InfoArea
                    title='직항여부'
                    value={quoteInfo.step2?.isDirect ? '예' : '아니오'}
                />
                <InfoArea
                    title='선호 선사'
                    value={quoteInfo.step2?.carrierRequired ? quoteInfo.step2.preferredCarrier : '없음'}
                />
                {
                    quoteInfo.step2?.isShipperName &&
                    <InfoArea
                        title='실화주명'
                        value={quoteInfo.step2?.shipperName}
                    />
                }
                {
                    file &&
                    <InfoAreaFile
                        title='첨부서류'
                        file={file}
                    />
                }
            </div>
        </div >
    )
}

export default Third